import angular from 'angular';
import uiRouter from 'angular-ui-router';
import SignIn from './sign-in';
import signUp from './sign-up';
import Auth from './auth';
import PasswordReset from './password-reset';
import FourOFour from './four-o-four';
import routing from './oauth.routes';
import VerifyEmail from './verify-email';

export default angular
  .module('accountsApp.oauth', [
    uiRouter, SignIn, PasswordReset, FourOFour, Auth, signUp, VerifyEmail,
  ])
  .config(routing)
  .name;



// WEBPACK FOOTER //
// ./client/app/oauth/index.js